import React, { Component } from 'react';
import { FormGroup } from 'reactstrap';
import { RotateSpinLoader } from 'react-css-loaders';

class Loader extends Component {
  constructor(props, context) {
    super(props);
  }

  render() {
    return (
      <FormGroup className={this.props.loaderStyle}>
        <div className="btn">
          <RotateSpinLoader
            color={'#222A5A'}
            size={5}
          />
        </div>
      </FormGroup>
    );
  }
}
export default Loader;